import { useNavigate } from 'react-router-dom';
import ChangePasswordModal from './ChangePasswordModal';

const ChangePasswordPage = () => {
  const navigate = useNavigate();

  return (
    <ChangePasswordModal
      isOpen
      onClose={() => navigate('/dashboard')}
    />
  );
};
export default ChangePasswordPage;
